import { render, staticRenderFns } from "./historyScript.vue?vue&type=template&id=ee2dfdc8"
import script from "./historyScript.vue?vue&type=script&lang=js"
export * from "./historyScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports